const VITE_API_BASE =
  import.meta.env.VITE_API_BASE ||
  'https://us-central1-kindkudos-prod.cloudfunctions.net';

async function request(path, options = {}) {
  const res = await fetch(`${VITE_API_BASE}${path}`, {
    method: options.method || 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });

  let data = null;
  try {
    data = await res.json();
  } catch {
    // non-JSON response
  }

  if (!res.ok) {
    const err = new Error((data && data.error) || `HTTP ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export function sendKudos({
  recipientName,
  recipientEmail,
  message,
  senderEmail,
  turnstileToken,
  parentKudosId,
}) {
  return request('/sendKudos', {
    method: 'POST',
    body: {
      recipientName,
      recipientEmail,
      message,
      senderEmail,
      turnstileToken,
      parentKudosId,
    },
  });
}

export function sendKudosBatch({ items, senderEmail, turnstileToken, parentKudosId }) {
  return request('/sendKudosBatch', {
    method: 'POST',
    body: { items, senderEmail, turnstileToken, parentKudosId },
  });
}

export function draftKudos({ recipientFirstName, trait }) {
  return request('/draftKudos', {
    method: 'POST',
    body: { recipientFirstName, trait },
  });
}

export function getKudos(id) {
  return request(`/getKudos?id=${encodeURIComponent(id)}`);
}

export function getChain(rootId) {
  return request(`/getChain?rootId=${encodeURIComponent(rootId)}`);
}

export function getStats() {
  return request('/getStats');
}
